import { ReportIdConst } from '../../enums/report.enum';
import { formatSaveDateFrom, formatSaveDateTo } from '../../reducers/TimeReducer.js'

const formatDate = (data, type, format) => {
  let formatedDate = '';
  if (type === 'from') {
    formatedDate = formatSaveDateFrom(data);
  } else {
    formatedDate = formatSaveDateTo(data);
  }
  return formatedDate ? formatedDate.split(' ')[0] : format == 'csv' ? null : '';
};

export const processParameters = (ReportID, formData, format = 'report') => {
  switch (ReportID) {
    case ReportIdConst.CADDataByMonth:
      return processCadDataByMonth(formData, format);
    case ReportIdConst.CADPialSummary:
      return processCadPialSummary(formData, format);
    case ReportIdConst.CADEventsData:
      return processCadEventsData(formData, format);
    default:
      return {};
  }
};
const processCadDataByMonth = (formData, format) => {
  if (!formData) return {};
  const newForm = {
    Year: formData?.year?.Code ?? new Date().getFullYear(),
    AgencyId: formData?.agency?.Code,
  };
  return newForm;
};

const processCadEventsData = (formData, format) => {
  if (!formData) return {};
  const newForm = {
    AgencyId: formData?.agency?.Code,
    startDate: formatDate(formData.startDate, 'from', format),
    endDate: formatDate(formData.endDate, 'to', format),
    timeFrom: formData?.timeFrom?.Code === 'Started' ? 'EventStartDateTime' : formData?.timeFrom?.Code,
    timeTo: formData?.timeTo?.Code === 'Started' ? 'EventStartDateTime' : formData?.timeTo?.Code,
    timeFormat: formData?.timeFormat?.Code,
    target: formData.target !== undefined && formData.target !== null && formData.target !== ''
      ? Number(formData.target)
      : null,
    isEventsRequired: !!formData.isEventsRequired,
  };
  return newForm;
};

const processCadPialSummary = (formData, format) => {
  if (!formData) return {};
  const newForm = {
    AgencyId: formData?.agency?.Code,
    startDate: formatDate(formData.startDate, 'from', format),
    endDate: formatDate(formData.endDate, 'to', format),
  };
  return newForm;
};

export const reportNameMapper = (id) => {
  switch (id) {
    case ReportIdConst.CADDataByMonth:
      return 'Cad Data By Month Report';
    case ReportIdConst.CADPialSummary:
      return 'Cad Pial summary Report'
    case ReportIdConst.CADEventsData:
      return 'CAD Events Data Report'
    default:
      return 'Report';
  }
};
